/* template */
<template><mpx-view ref="__mpx_ref_swipercontainer__" :class="({ 'swiper-container-vertical': vertical })" @touchstart="handleTouchStart" @touchmove="handleTouchMove" @touchend="handleTouchEnd" class="swiper-container"><div :style="[(wrapperStyle)] | transRpxStyle" class="swiper-wrapper"><SwipeItem v-for="(item, index) in (loopedSwiperList)" :key="item.index" :index="(index)" :item="(item)" :active="(activeIndex === index)" :noTransition="(noTransition)" :spaceBetween="(spaceBetween)" :imageStyle="(imageStyle)" :itemSize="(itemSize)" :displayMultipleItems="(displayMultipleItems)" @click="handleClick"/></div></mpx-view></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"mf1757408"}'>
  .swiper-container
    width 100%
    height 100%
    overflow hidden
    position relative
    display flex
    justify-content flex-start
    align-items center
  .swiper-wrapper
    width 100%
    height 100%
    display flex
    transition transform 0.3s ease-in-out
  .swiper-container-vertical
    flex-direction column
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "mf1757408"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findexf1757408%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findexf1757408%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["mf1757408"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/indexf1757408/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'SwipeItem':getComponent(require("./ts-web-swiper-item.mpx?isComponent&outputPath=components%2Fts-web-swiper-itemae280c76%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
